import { Link } from "react-router-dom";
import ROLES from "../../utils/constants";
import {
	getDataFromJwt,
	isAdmin,
	isUser,
	toastMaker,
} from "../../utils/utility";
import matrimonyInstance from "../../utils/axios";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { SHORTLIST_PROFILES } from "../../API_LIST";

function ProfileCard2({ profilesData, errorMessage, showShortList }) {
	const roleid = getDataFromJwt("role");
	const [profiles, setProfiles] = useState(null);

	function getParent() {
		if (roleid) {
			return ROLES[roleid].landingUrl;
		}
	}

	useEffect(() => {
		setProfiles(profilesData);
	}, [profilesData]);

	const parent = getParent();

	let selectedProfile = useSelector((state) => state.auth.currentProfile);
	async function shortListProfile(index, id) {
		let data = {
			profile_id: selectedProfile.profile_id,
			shortlist_id: id,
		};

		await matrimonyInstance.post(SHORTLIST_PROFILES, data).then((response) => {
			let _profiles = [...profiles];
			_profiles[index].isShortlisted = true;
			toastMaker("Profile added to shortlist", "success");
			setProfiles(_profiles);
		});
	}

	async function unShortListProfile(index, id) {
		let payload = {
			profile_id: selectedProfile.profile_id,
			shortlist_id: id,
		};

		await matrimonyInstance
			.delete(SHORTLIST_PROFILES, { data: payload })
			.then((response) => {
				let _profiles = [...profiles];
				_profiles[index].isShortlisted = false;
				toastMaker("Profile removed from shortlist", "success");
				setProfiles(_profiles);
			});
	}

	return (
		<>
			{profiles &&
				profiles?.map((item, index) => (
					<div className="profile-card" key={item.profile_id}>
						{isUser() && showShortList ? (
							item.isShortlisted ? (
								<div
									className="d-flex justify-content-end"
									onClick={() => unShortListProfile(index, item.profile_id)}
								>
									<img src="../../assets/images/bat-img/like.svg" />
								</div>
							) : (
								<div
									className="d-flex justify-content-end"
									onClick={() => shortListProfile(index, item.profile_id)}
								>
									<img src="../../assets/images/bat-img/unlike.svg" />
								</div>
							)
						) : null}
						<Link
							to={`${parent}/view-profile/${item.profile_id}`}
							key={item.profile_id}
						>
							<div className="d-flex gap-4 pt-10">
								<img
									src={
										item?.profile === "groom"
											? "../../assets/images/bat-img/profile-male.svg"
											: "../../assets/images/bat-img/profile-female.svg"
									}
									className="user-image"
									alt="Profile"
								/>
								<div className="w-100">
									<div className="d-flex align-items-start justify-content-between gap-3 mb-15">
										<h5 className="tetx-blue-card">
											{(item?.first_name && item.first_name !== "hidden") ||
											(item?.last_name && item.last_name !== "hidden") ? (
												<span className="tetx-blue-card">
													{item?.first_name && item.first_name !== "hidden"
														? item.first_name
														: "First Name"}{" "}
													{item?.last_name && item.last_name !== "hidden"
														? item.last_name
														: "Last Name"}
												</span>
											) : (
												<span>{item?.profile_id}</span>
											)}
										</h5>
										{isAdmin() ? (
											<h5 className="tetx-blue-card">{item?.profile_id}</h5>
										) : null}
									</div>
									<div className="d-flex gap-3 mb-10 font-14">
										<img src="../../assets/images/bat-img/profile-job.svg" />
										<span>{item?.gothram}</span>
									</div>

									<div className="d-flex gap-3 mb-10 font-14">
										<img src="../../assets/images/bat-img/profile-job.svg" />
										{item?.profession === "hidden" ? (
											<span className="text-blur">Profession</span>
										) : (
											<span>{item?.profession}</span>
										)}
									</div>
									<div className="d-flex gap-3 font-14">
										<img src="../../assets/images/bat-img/profile-location.svg" />
										{item?.current_location === "hidden" ? (
											<span className="text-blur">Current Location</span>
										) : (
											<span>{item?.current_location}</span>
										)}
									</div>
								</div>
							</div>
						</Link>
					</div>
				))}
			{!profiles && !errorMessage ? <p>Loading profiles</p> : null}
			{!profiles && errorMessage ? <p>{errorMessage}</p> : null}
			{profiles?.length < 1 ? <p>No Profile to display.</p> : null}
		</>
	);
}

export default ProfileCard2;
